<template>
  <div class="fullwidth">
    <h2>
        <span style="color:#cf0a2c">Commissioning an animation?</span> Follow our simple steps to getting
        an accurate quote and achieving a smooth, successful production.
    </h2>
    <div class="animcom-content">
      <div class="choice-row">
          <div class="mini-column space-right">
              <div class="ol-heading">
                  <x-img src="/img/comm/red-heading.svg" />
                  <div class='oh-text'>What have you got in mind?</div>
              </div>
              <div class="intro-blue">
                  Tell us as much as you can so we 
                  can give you a realistic quote for
                  making your animation.
              </div>
          </div>
          <div class="mini-column fix1" v-on:click="switchToSimple()" id="simpleButton" :class="{sel: mode === 'simple'}">
              <div class="circular-button">
                  <div class="circle-text">
                      A
                      SIMPLE
                      ANIMATION
                  </div>
                  
              </div>
              <div class="icon-caption">
                  
                      Like an animated gif,
                      basic web animation, or
                      an animated illustration
              </div>
          </div>
          <div class="mini-column nobut">
              <div class="no-button">
                  OR
              </div>
          </div>
          <div class="mini-column fix1" v-on:click="switchToComplex()" id="complexButton" :class="{sel: mode === 'complex'}">
              <div class="circular-button">
                  <div class="circle-text">
                      A MORE
                      COMPLEX
                      ANIMATION
                  </div>
              </div>
              <div class="icon-caption">
                  Broadcast multi-character
                  multi-scene 3D, mix media
                  and/or with video or
                  typographic elements
              </div>
          </div>
      </div>
      <div v-show="mode === 'simple'">
          <div class="icon-row">
              <div class="animator-chunk" data-order="0">
                  <div class="icon-gif">
                
                      <x-img src="/img/comm/static/01_Format.gif" />
                      <div class="icon-overlay">
                          Format &amp; length
                      </div>
                  </div>
                  <div class="icon-caption">
                      <ul>
                          <li>What resolution?</li>
                          <li>Frames per second?</li>
                          <li>Web or broadcast?</li>
                          <li>One version/variations?</li>
                          <li>Running time?</li>
                      </ul>
                  </div>
              </div>
              <div class="animator-chunk" data-order="1">
                  <div class="icon-gif">
                      <x-img src="/img/comm/static/03_Style.gif" />
                      <div class="icon-overlay">
                          Style
                      </div>
                  </div>
                  <div class="icon-caption">
                      <ul>
                          <li>2D?</li>
                          <li>3D?</li>
                          <li>Traditional?</li>
                          <li>Modern?</li>
                          <li>Examples you like?</li>
                      </ul>
                  </div>
              </div>
              <div class="animator-chunk" data-order="2">
                  <div class="icon-gif">
                  
                      <x-img src="/img/comm/static/04_Chars.gif" />
                      <div class="icon-overlay">
                          Characters
                      </div>
                  </div>
                  <div class="icon-caption">
                      <ul>
                          <li>How many?</li>
                          <li>Complexity of each?</li>
                          <li>3D turns/angles?</li>
                          <li>Realistic/cartoon?</li>
                      </ul>
                  </div>
              </div>
              <div class="animator-chunk" data-order="3">
                  <div class="icon-gif">
                  
                      <x-img src="/img/comm/static/05_Backs.gif" />
                      <div class="icon-overlay">
                          Backgrounds
                      </div>
                  </div>
                  <div class="icon-caption">
                      <ul>
                          <li>How many?</li>
                          <li>How detailed?</li>
                          <li>Do they animate?</li>
                      </ul>
                  </div>
              </div>
              <div class="animator-chunk" data-order="4">
                  <div class="icon-gif">
                  
                      <x-img src="/img/comm/static/06_Script.gif" />
                      <div class="icon-overlay">
                          Script
                      </div>
                  </div>
                  <div class="icon-caption">
                      <ul>
                          <li>Is there a script/brief?</li>
                          <li>Is it finalised?</li>
                          <li>Scope for tweaks?</li>
                      </ul>
                  </div>
              </div>
              <div class="animator-chunk end" data-order="5">
                  <div class="icon-gif">
                  
                      <x-img src="/img/comm/static/07_Budget.gif" usSrc="/img/comm/static/07_Budget_us.gif" />
                      <div class="icon-overlay">
                          Budget
                      </div>
                  </div>
                  <div class="icon-caption">
                      With all or most of this
                      information, we can
                      provide you with a
                      realistic production
                      budget for your
                      animation. Due to the production costs of animation, 
                      an upfront fee will be expected before the job commences
                  </div>
              </div>
          </div>
          <div class="dashline"></div>
          <!--- SIMPLE ROW 2 ---------------------------------------- -->
          <div class="icon-row">
              <div class="grouped-col">
                  <div class="gr-heading">
                      Preproduction
                  </div>
                  <div class="chunks">
                      <div class="animator-chunk" data-order="6">
                          <div class="icon-gif">
                          
                              <x-img src="/img/comm/static/08_Scheme.gif" />
                              <div class="icon-overlay">
                                  Pencil<br />
                                  Roughs
                              </div>
                          </div>
                          <div class="icon-caption">
                              The animator prepares
                              pencil roughs of
                              character(s), scheme
                              and set and prop
                              designs.
                          </div>
                      </div>
                      <div class="animator-chunk" data-order="7">
                          <div class="icon-gif">
                          
                              <x-img src="/img/comm/static/11_SBoard.gif" />
                              <div class="icon-overlay">
                                  Storyboard
                              </div>
                          </div>
                          <div class="icon-caption">
                              If required, the animator
                              will put together a quick
                              storyboard to avoid any
                              confusion in the
                              production phase.
                          </div>
                      </div>
                  </div>
              </div>
              <div class="grouped-col">
                  <div class="gr-heading">
                      Production
                  </div>
                  <div class="chunks">
                      <div class="animator-chunk" data-order="8">
                          <div class="icon-gif">
                          
                              <x-img src="/img/comm/static/16_Assets.gif" />
                              <div class="icon-overlay">
                                  Artworking
                              </div>
                          </div>
                          <div class="icon-caption">
                              Defining the character
                              style, colouring up the
                              pencils from preproduction,
                              ensuring the transition
                              from drawn design to
                              model is as expected.
                          </div>
                      </div>
                      <div class="animator-chunk" data-order="9">
                          <div class="icon-gif">
                          
                              <x-img src="/img/comm/static/17_Animation.gif" />
                              <div class="icon-overlay">
                                  Animation
                              </div>
                          </div>
                          <div class="icon-caption">
                          
                          </div>
                      </div>
                  </div>
              </div>
              <div class="grouped-col">
                  <div class="gr-heading" style="opacity:0">
                      <br />
                  </div>
                  <div class="chunks">
                      <div class="animator-chunk flashing" data-order="10">
                          <x-img src="/img/comm/flash.svg" class="flash-surround" />
                          <div class="icon-gif">
                  
                              <x-img src="/img/comm/static/23_Delivery.gif" />
                              <div class="icon-overlay">
                                  Finished
                                  Animation
                              </div>
                          </div>
                          <div class="icon-caption">
                          
                          </div>
                      </div>
                  </div>
              </div>
          </div>
      </div>
      <!-- COMPLEX STARTS ------------------------------------------------- -->
      <div v-show="mode === 'complex'">
          <div class="icon-row">
              <div class="animator-chunk" data-order="0">
                  <div class="icon-gif">
                
                      <x-img src="/img/comm/static/01_Format.gif" />
                      <div class="icon-overlay">
                          Format
                      </div>
                  </div>
                  <div class="icon-caption">
                      <ul>
                          <li>What resolution?</li>
                          <li>Frames per second?</li>
                          <li>Web or broadcast?</li>
                          <li>One version/variations?</li>
                      </ul>
                  </div>
              </div>
              <div class="animator-chunk" data-order="1">
                  <div class="icon-gif">
                
                      <x-img src="/img/comm/static/02_Length.gif" />
                      <div class="icon-overlay">
                          Length
                      </div>
                  </div>
                  <div class="icon-caption">
                      <ul>
                          <li>Running time?</li>
                      </ul>
                  </div>
              </div>
              <div class="animator-chunk" data-order="2">
                  <div class="icon-gif">
                      <x-img src="/img/comm/static/03_Style.gif" />
                      <div class="icon-overlay">
                          Style
                      </div>
                  </div>
                  <div class="icon-caption">
                      <ul>
                          <li>2D?</li>
                          <li>3D?</li>
                          <li>Traditional?</li>
                          <li>Modern?</li>
                          <li>Examples you like?</li>
                      </ul>
                  </div>
              </div>
              <div class="animator-chunk" data-order="3">
                  <div class="icon-gif">
                  
                      <x-img src="/img/comm/static/04_Chars.gif" />
                      <div class="icon-overlay">
                          Characters
                      </div>
                  </div>
                  <div class="icon-caption">
                      <ul>
                          <li>How many?</li>
                          <li>Complexity of each?</li>
                          <li>Secondary animation? (bells, hair, capes etc)</li>
                          <li>Complex 3D turns?</li>
                          <li>Funny angles?</li>
                          <li>Lifelike moves?</li>
                          <li>Cartoon fashion?</li>
                      </ul>
                  </div>
              </div>
              <div class="animator-chunk" data-order="4">
                  <div class="icon-gif">
                  
                      <x-img src="/img/comm/static/05_Backs.gif" />
                      <div class="icon-overlay">
                          Backgrounds
                      </div>
                  </div>
                  <div class="icon-caption">
                      <ul>
                          <li>How many?</li>
                          <li>How detailed?</li>
                          <li>Do they animate?</li>
                      </ul>
                  </div>
              </div>
              <div class="animator-chunk" data-order="5">
                  <div class="icon-gif">
                  
                      <x-img src="/img/comm/static/06_Script.gif" />
                      <div class="icon-overlay">
                          Script
                      </div>
                  </div>
                  <div class="icon-caption">
                      <ul>
                          <li>Is there one?</li>
                          <li>Is it finalised?</li>
                          <li>Scope for tweaks?</li>
                      </ul>
                  </div>
              </div>
              <div class="animator-chunk end" data-order="6">
                  <div class="icon-gif">
                  
                      <x-img src="/img/comm/static/07_Budget.gif" usSrc="/img/comm/static/07_Budget_us.gif" />
                      <div class="icon-overlay">
                          Budget
                      </div>
                  </div>
                  <div class="icon-caption">
                      With all or most of this
                      information, we can
                      provide you with a
                      realistic production
                      budget for your
                      animation.
                      Due to the production costs of animation, an upfront fee will be expected before the job commences
                  </div>
              </div>
          </div>
          <div class="dashline"></div>
          <!-- PREPRODUCTION --------------------------------------------------------------- -->
          <div class="icon-row">
              <div class="intro-row">
                  <div id="hellow">
                      <div class="ol-heading">
                          <x-img src="/img/comm/red-heading.svg" />
                          <div class='oh-text pointy'>Preproduction</div>
                      </div>
                  </div>
                  <div class="intro-blue2">
                      With the animation format, length, style, characters, backgrounds, 
                      script and budget agreed, we can take the concept forward.
                  </div>
              </div>
          </div>
          <div class="icon-row">
              <div class="animator-chunk" data-order="7">
                  <div class="icon-gif">
                
                      <x-img src="/img/comm/static/08_Scheme.gif" />
                      <div class="icon-overlay">
                          Scheme design
                      </div>
                  </div>
                  <div class="icon-caption">
                      An optional step for more
                      complex animations, a
                      scheme might feature
                      one character and a
                      partial background to
                      define the style for the
                      rest of the production.
                  </div>
              </div>
              <div class="animator-chunk" data-order="8">
                  <div class="icon-gif">
                
                      <x-img src="/img/comm/static/09_CharDes.gif" />
                      <div class="icon-overlay">
                          Character Design
                      </div>
                  </div>
                  <div class="icon-caption">
                      If the character style is
                      agreed, we will work up
                      a rough set of pencil
                      characters for approval
                      before taking them to
                      colour.
                  </div>
              </div>
              <div class="animator-chunk" data-order="9">
                  <div class="icon-gif">
                      <x-img src="/img/comm/static/10_SetDes.gif" />
                      <div class="icon-overlay">
                          Set / Prop
                          Design
                      </div>
                  </div>
                  <div class="icon-caption">
                      Starting with the
                      agreed concept, we
                      will work up a rough
                      set of pencil and prop
                      designs for approval
                      before taking them to
                      colour.
                  </div>
              </div>
              <div class="animator-chunk" data-order="10">
                  <div class="icon-gif">
                  
                      <x-img src="/img/comm/static/11_SBoard.gif" />
                      <div class="icon-overlay">
                          Storyboard
                      </div>
                  </div>
                  <div class="icon-caption">
                      Begins with a rough
                      working document which
                      allows for some changes.
                      A storyboard can also
                      identify what will be
                      hard to do, blow the
                      budget or interfere with
                      a smooth production.
                  </div>
              </div>
              <div class="animator-chunk" data-order="11">
                  <div class="icon-gif">
                  
                      <x-img src="/img/comm/static/12_Animatic.gif" />
                      <div class="icon-overlay">
                          Animatic
                      </div>
                  </div>
                  <div class="icon-caption">
                      An option. Essentially an
                      animated storyboard
                      which, by identifying
                      things like any overly
                      long section, can save a
                      lot of time later. Uses
                      the voiceover or we can
                      lay down a rough voice.
                  </div>
              </div>
              <div class="animator-chunk end" data-order="12">
                  <div class="icon-gif">
                  
                      <x-img src="/img/comm/static/13_VoiceOver.gif" />
                      <div class="icon-overlay">
                          Voiceover
                      </div>
                  </div>
                  <div class="icon-caption">
                      If required, it’s time to
                      choose your voiceover
                      artist. This is sometimes
                      done before the
                      animatic.
                  </div>
              </div>
              
          </div>
          <div class="dashline"></div>
          <!-- PRODUCTION -->
          <div class="icon-row">
              <div class="intro-row">
                  <div>
                      <div class="ol-heading">
                          <x-img src="/img/comm/red-heading.svg" />
                          <div class='oh-text pointy'>Production</div>
                      </div>
                  </div>
                  <div class="intro-blue2">
                      Now we’re all set to bring each frame of the
                      story to life and add those touches that make
                      your animation so engaging and memorable.
                  </div>
              </div>
          </div>
          <div class="icon-row">
              <div class="animator-chunk" data-order="13">
                  <div class="icon-gif">
                
                      <x-img src="/img/comm/static/14_Modelling.gif" />
                      <div class="icon-overlay">
                          Modelling
                      </div>
                  </div>
                  <div class="icon-caption">
                    
                  </div>
              </div>
              <div class="animator-chunk" data-order="14">
                  <div class="icon-gif">
                
                      <x-img src="/img/comm/static/15_AniTests.gif" />
                      <div class="icon-overlay">
                          Animation Tests
                      </div>
                  </div>
                  <div class="icon-caption">
                      
                  </div>
              </div>
              <div class="animator-chunk" data-order="15">
                  <div class="icon-gif">
                      <x-img src="/img/comm/static/16_Assets.gif" />
                      <div class="icon-overlay">
                          Asset Generation
                      </div>
                  </div>
                  <div class="icon-caption">
                      
                  </div>
              </div>
              <div class="animator-chunk" data-order="16">
                  <div class="icon-gif">
                  
                      <x-img src="/img/comm/static/17_Animation.gif" />
                      <div class="icon-overlay">
                          Animator
                      </div>
                  </div>
                  <div class="icon-caption">
                      
                  </div>
              </div>
              <div class="animator-chunk" data-order="17">
                  <div class="icon-gif">
                  
                      <x-img src="/img/comm/static/18_Compositing.gif" />
                      <div class="icon-overlay">
                          Compositing
                      </div>
                  </div>
                  <div class="icon-caption">
                      
                  </div>
              </div>
              <div class="animator-chunk end" data-order="18">
                  <div class="icon-gif">
                  
                      <x-img src="/img/comm/static/19_Render.gif" />
                      <div class="icon-overlay">
                          Final Renders
                      </div>
                  </div>
                  <div class="icon-caption">
                      
                  </div>
              </div>
              
          </div>
          <!-- PRODUCTION ENDS -->
          <div class="dashline"></div>
          <!-- POST PRODUCTION -->
          <div class="icon-row">
              <div class="intro-row">
                  <div>
                      <div class="ol-heading">
                          <x-img src="/img/comm/red-heading.svg" />
                          <div class='oh-text pointy'>Postproduction</div>
                      </div>
                  </div>
                  <div class="intro-blue2">
                      Finally, we render and deliver a full quality
                      Pro Res file of your animation.
                  </div>
              </div>
          </div>
          <div class="icon-row">
              <div class="animator-chunk" data-order="19">
                  <div class="icon-gif">
                
                      <x-img src="/img/comm/static/20_Edit.gif" />
                      <div class="icon-overlay">
                          Editing
                      </div>
                  </div>
                  <div class="icon-caption">
                    
                  </div>
              </div>
              <div class="animator-chunk" data-order="20">
                  <div class="icon-gif">
                
                      <x-img src="/img/comm/static/21_SoundFX.gif" />
                      <div class="icon-overlay">
                          Sound design
                      </div>
                  </div>
                  <div class="icon-caption">
                      
                  </div>
              </div>
              <div class="animator-chunk" data-order="21">
                  <div class="icon-gif">
                      <x-img src="/img/comm/static/22_Mastering.gif" />
                      <div class="icon-overlay">
                          Mastering
                      </div>
                  </div>
                  <div class="icon-caption">
                      
                  </div>
              </div>
              <div class="animator-chunk flashing" data-order="22">
                  <x-img src="/img/comm/flash.svg" class="flash-surround" />
                  <div class="icon-gif">
                  
                      <x-img src="/img/comm/static/23_Delivery.gif" />
                      <div class="icon-overlay">
                          Finished
                          Animation
                      </div>
                  </div>
                  <div class="icon-caption">
                          
                  </div>
              </div>
              <div class="animator-chunk end" style="color:#cf0a2c;margin-left:40px;width:auto;">
                
                      Any changes beyond this point are
                      possible but will incur additional
                      costs and impact timing.
                  
              </div>
              
          </div>
      </div>
     <!-- COMPLEX ENDS ------------------------------------------------- -->
      <div style="margin:60px 0;padding:10px 0"></div>
    </div>
  </div>
</template>

<script>
import ExImg from '@/components/widgets/ExImg.vue'
export default {
  components:{
    'x-img': ExImg
  },
  data () {
    return {
      mode: 'simple'
    }
  },
  methods: {
    async switchToSimple () {
      this.mode = 'simple'
    },
    async switchToComplex () {
      this.mode = 'complex'
    }
  }


}
</script>

<style>

</style>
<style scoped>
h2 {
      color: #000;
      font-size: 32px;
      font-weight: normal;
      margin-bottom: 16px;
      font-family:'Trebuchet MS', 'Lucida Sans Unicode', 'Lucida Grande', 'Lucida Sans', Arial, sans-serif;
  }

.animcom-content{
  max-width:1200px;
  margin-left:auto;
  margin-right:auto;
}
  .choice-row{
      display:flex;
      justify-content:flex-start;
      font-family:'Trebuchet MS', 'Lucida Sans Unicode', 'Lucida Grande', 'Lucida Sans', Arial, sans-serif;
      margin-top:50px;
  }

  .ol-heading{
      
      padding:16px;
      color:#cf0a2c;
      text-transform:uppercase;
      font-size:24px;
      white-space:nowrap;
      position:relative;
      
  }

  .mini-column.space-right{
      margin-right:40px;
  }

  .mini-column.fix1{
      width:150px;
      display:flex;
      flex-direction:column;
      
      text-align:center;
      align-items:center;
      opacity:0.5;
      cursor:pointer;
  }

  .mini-column.fix1.sel, .mini-column.fix1:hover{
      opacity:1.0;
  }

  .mini-column.nobut{
      text-align:center;
      padding:10px;
  }

  .ol-heading img{
      position:absolute;
      left:0;
      top:0;
      width:100%;
      height:100%;
      z-index:10;
      object-fit:fill;
  }

  .oh-text{
      position:relative;
      z-index:20;
  }

  .pointy{
      padding-right:45px;
      background-image:url('/img/comm/arrow-red.svg');
      background-size:16px;
      background-position:right 10px center;
      background-repeat:no-repeat;
  }

  .circular-button{
      background-color:#cf0a2c;
      border-radius:50%;
      color:#fff;
      width:133px;
      height:133px;
      text-align:center;
      position:relative;
      
      cursor:pointer;
  }

  

  .circle-text{
      position:absolute;
      top:50%;
      left:50%;
      transform:translate(-50%, -50%);
  }

  .no-button{
      padding-top:50px;
      color:#2fabd6;
      text-align:center;
  }

  .icon-caption{
      margin-top:16px;
      font-size:14px;
  }

  .intro-blue{
      width:300px;
      color:#2fabd6;
      font-size:18px;
      padding:16px;
  }

  .intro-blue2{
      

      width:400px;
      color:#2fabd6;
      font-size:18px;
      padding:0 20px;
  }

  .icon-row{
      padding-top:30px;
      display:flex;
      justify-content:flex-start;
      font-family:'Trebuchet MS', 'Lucida Sans Unicode', 'Lucida Grande', 'Lucida Sans', Arial, sans-serif;
  }

  .animator-chunk{
      padding-right:30px;
      width:130px;
      background-image:url(/img/comm/arrow-r.svg);
      background-size:14px;
      background-position:right 5px top 60px;
      background-repeat:no-repeat;
      position:relative;
  }

  .animator-chunk.end{
      background:none;
  }

  .animator-chunk.flashing{
      padding:0 50px;
      background:none;
  }

  .flash-surround{
      position:absolute;
      top:45%;
      left:50%;
      width:280px;
      transform:translate(-50%,-50%);
      opacity:0.6;
  }

  .icon-gif{
      position:relative;
  }

  .icon-overlay{
      position:absolute;
      top:25%;
      left:50%;
      transform:translate(-50%, -50%);
      text-align:center;
      width:100%;
      padding:10px;
      color:#fff;
      box-sizing:border-box;
      font-weight:bold;
      text-transform:uppercase;
      font-size:14px;
  }

  .animator-chunk .icon-caption{
      font-size:12px;
  }

  .icon-caption ul{
      padding-left:12px;
  }

  .grouped-col{
      display:flex;
      flex-direction:column;
  }

  .chunks{
      display:flex;
  }

  .gr-heading{
      text-align:center;
      color:#cf0a2c;
      font-size:18px;
      text-transform:uppercase;
      padding-bottom:80px;
      background-image:url(/img/comm/bracket.svg);
      background-size:90%;
      background-position:center bottom;
      background-repeat:no-repeat;
  }

  .dashline{
      width:100%;
      background-image:url(/img/comm/dash.svg);
      background-size:20px;
      background-repeat:repeat no-repeat;
      padding:5px 0;
      margin:20px 0;
  }

  .intro-row{
      display:flex;
      justify-content:flex-start;
  }

  #complex{
      display:none;
  }
</style>